import { render, staticRenderFns } from "./MenuRecursive.vue?vue&type=template&id=16efa8f0&scoped=true"
import script from "./MenuRecursive.vue?vue&type=script&lang=js"
export * from "./MenuRecursive.vue?vue&type=script&lang=js"
import style0 from "./MenuRecursive.vue?vue&type=style&index=0&id=16efa8f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16efa8f0",
  null
  
)

export default component.exports